var map = {
	"./Sample": [
		4111,
		111
	],
	"./Sample/": [
		4111,
		111
	],
	"./Sample/index": [
		4111,
		111
	],
	"./Sample/index.js": [
		4111,
		111
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1629;
module.exports = webpackAsyncContext;